// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-modal {
  margin-top: var(--base-sizes-8);
  margin-bottom: var(--base-sizes-8);
  border-radius: var(--base-sizes-1-5);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--base-colors-white-white100) / var(--tw-bg-opacity));
  box-shadow: 0 0 20px #0003;
}

.overlay-modal--small {
  width: 100%;
  max-width: 500px;
}

.overlay-modal--content-default {
  width: 100%;
  max-width: 54rem;
}

.overlay-modal__body {
  padding: var(--base-sizes-4);
}

.overlay-modal__header {
  border-width: 0;
  border-bottom-width: var(--base-sizes-1px);
  --tw-border-opacity: 1;
  border-style: solid;
  border-color: rgb(232 232 232 / var(--tw-border-opacity));
  padding: var(--base-sizes-4);
}

.overlay-modal__header > h4 {
  margin: var(--base-sizes-0);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.overlay-modal__footer {
  border-width: 0;
  border-top-width: var(--base-sizes-1px);
  --tw-border-opacity: 1;
  border-style: solid;
  border-color: rgb(232 232 232 / var(--tw-border-opacity));
  padding: var(--base-sizes-4);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/OverlayModal/OverlayModal.css","webpack://./services/frontend/app/components/OverlayModal/OverlayModal.css"],"names":[],"mappings":"AADA;ECEE,+BAA+B;EAC/B,kCAAkC;EAClC,oCAAoC;EACpC,kBAAkB;EAClB,+EAA+E;EAC/E,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;EACnB,yDAAyD;EACzD,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,sBAAsB;EACtB,mBAAmB;EACnB,yDAAyD;EACzD,4BAA4B;AAC9B","sourcesContent":[".overlay-modal {\n\n  margin-top: var(--base-sizes-8);\n\n  margin-bottom: var(--base-sizes-8);\n\n  border-radius: var(--base-sizes-1-5);\n\n  --tw-bg-opacity: 1;\n\n  background-color: rgb(var(--base-colors-white-white100) / var(--tw-bg-opacity));\n\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n}\n\n.overlay-modal--small {\n  max-width: 500px;\n  width: 100%;\n}\n\n.overlay-modal--content-default {\n\n  max-width: 54rem;\n\n  width: 100%;\n}\n\n.overlay-modal__body {\n\n  padding: var(--base-sizes-4);\n}\n\n.overlay-modal__header {\n\n  border-width: 0;\n\n  border-bottom-width: var(--base-sizes-1px);\n\n  border-style: solid;\n\n  --tw-border-opacity: 1;\n\n  border-color: rgb(232 232 232 / var(--tw-border-opacity));\n\n  padding: var(--base-sizes-4);\n}\n\n.overlay-modal__header > h4 {\n\n  margin: var(--base-sizes-0);\n\n  overflow: hidden;\n\n  text-overflow: ellipsis;\n\n  white-space: nowrap;\n}\n\n.overlay-modal__footer {\n\n  border-width: 0;\n\n  border-top-width: var(--base-sizes-1px);\n\n  border-style: solid;\n\n  --tw-border-opacity: 1;\n\n  border-color: rgb(232 232 232 / var(--tw-border-opacity));\n\n  padding: var(--base-sizes-4);\n}\n",".overlay-modal {\n  margin-top: var(--base-sizes-8);\n  margin-bottom: var(--base-sizes-8);\n  border-radius: var(--base-sizes-1-5);\n  --tw-bg-opacity: 1;\n  background-color: rgb(var(--base-colors-white-white100) / var(--tw-bg-opacity));\n  box-shadow: 0 0 20px #0003;\n}\n\n.overlay-modal--small {\n  width: 100%;\n  max-width: 500px;\n}\n\n.overlay-modal--content-default {\n  width: 100%;\n  max-width: 54rem;\n}\n\n.overlay-modal__body {\n  padding: var(--base-sizes-4);\n}\n\n.overlay-modal__header {\n  border-width: 0;\n  border-bottom-width: var(--base-sizes-1px);\n  --tw-border-opacity: 1;\n  border-style: solid;\n  border-color: rgb(232 232 232 / var(--tw-border-opacity));\n  padding: var(--base-sizes-4);\n}\n\n.overlay-modal__header > h4 {\n  margin: var(--base-sizes-0);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.overlay-modal__footer {\n  border-width: 0;\n  border-top-width: var(--base-sizes-1px);\n  --tw-border-opacity: 1;\n  border-style: solid;\n  border-color: rgb(232 232 232 / var(--tw-border-opacity));\n  padding: var(--base-sizes-4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
